import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import {
  cloneValue,
  expectObject,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";

export class DecorationAssetModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    previewSize: { label: "Preview size", fieldType: "json", minRows: 4 },
    effect: { label: "Effect", fieldType: "text" },
    numberOfColors: {
      label: "Number of colors",
      fieldType: "number",
      allowNull: true,
    },
    fabricName: { label: "Fabric name", fieldType: "text" },
    effectDetails: { label: "Effect details", fieldType: "json", minRows: 6 },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  previewSize!: number[];
  effect!: string;
  numberOfColors!: number | null;
  fabricName!: string;
  effectDetails!: Record<string, unknown>;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("previewSize", []);
    this.defineObservableValue("effect", "none");
    this.defineObservableValue("numberOfColors", null);
    this.defineObservableValue("fabricName", "");
    this.defineObservableValue("effectDetails", {});
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration asset");
    this.previewSize = Array.isArray(source.previewSize)
      ? source.previewSize.filter(
          (value): value is number => typeof value === "number"
        )
      : [];
    this.effect = readString(source, "effect");
    this.numberOfColors = readOptionalNumber(source, "numberOfColors");
    this.fabricName = readString(source, "fabricName");
    this.effectDetails =
      source.effectDetails &&
      typeof source.effectDetails === "object" &&
      !Array.isArray(source.effectDetails)
        ? cloneValue(source.effectDetails as Record<string, unknown>)
        : {};
    this.extra = splitKnown(source, [
      "previewSize",
      "effect",
      "numberOfColors",
      "fabricName",
      "effectDetails",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      previewSize: [...this.previewSize],
      ...(this.effect ? { effect: this.effect } : {}),
      ...(this.numberOfColors !== null
        ? { numberOfColors: this.numberOfColors }
        : {}),
      ...(this.fabricName ? { fabricName: this.fabricName } : {}),
      ...(Object.keys(this.effectDetails).length > 0
        ? { effectDetails: cloneValue(this.effectDetails) }
        : {}),
    };
  }
}
